<template>
  <div class="">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <DeleteModal
      :show="showDelete"
      @close="closeDelete"
      name="Report"
      @submit="doDeleteReport"
    />
    <div class="card" style="max-height: 40rem; overflow-y: auto">
      <div class="card-body">
        <div class="col-sm-12 col-md-12">
          <TableSearch @handleSearch="handleSearch" />
        </div>
        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead class="data-table-bg">
                  <tr>
                    <!-- <tr> -->
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="this.reports.length > 0">
                  <tr
                    :key="index"
                    v-for="(report, index) in paginatedData"
                    class="position-relative cursor-pointer"
                    style="border-bottom: unset;"
                    :class="{
                      'gray-bg': index % 2 !== 0,
                    }"
                  >
                    <td>{{ reports.indexOf(report) + 1 }}</td>
                    <td>{{ report.title }}</td>
                    <td>{{ report.devices.length }}</td>
                    <td
                      style="font-weight: bolder;padding-left: 2rem;position:relative"
                      @click="openOptions(index)"
                    >
                      <div class="d-flex align-items-center col-gap-1">
                        <span class="cursor-pointer" @click="openEdit(report)">
                          <IconEdit />
                        </span>
                        <span
                          @click="openDelete(report.id)"
                          class="cursor-pointer"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else align="center">
                  <tr align="center">
                    <td colspan="6">
                      {{ $t("no_rep_yet") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Pagination
          :pageCount="pageCount"
          :data="reports"
          :sizeperpage="sizeperpage"
          :pageNumber="pageNumber"
          :pages="pages"
          @goToLastPage="goToLastPage"
          @nextPage="nextPage"
          @handlePageChange="handlePageChange"
          @goToFirstPage="goToFirstPage"
          @prevPage="prevPage"
          @onchange="onchange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import store from "../../store/index";
import introJs from "intro.js";
import "intro.js/introjs.css";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
// import moment from "moment";
import DeleteModal from "../Modals/DeleteModal.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";

export default {
  name: "ReportTable",
  components: {
    Loading,
    IconEdit,
    IconDelete,
    DeleteModal,
    Pagination,
    TableSearch,
  },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      showDropdown: null,
      showDelete: false,
      id: "",
      dataTable: [],
    };
  },
  mixins: [tableMixin],
  mounted() {
    this.getReports(this.params).then(() => {
      this.isLoading = false;
    });
    // console.log(moment('00:00', 'H:mm').format('hh:mm a'));
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    introJs().exit();
    next();
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  methods: {
    ...mapActions(["getReports", "deletereport"]),
    openEdit(e) {
      this.$emit("open_edit_report", e);
      this.showDropdown = null;
    },
    openDelete(id) {
      this.id = id;
      this.showDelete = true;
    },
    closeDelete() {
      this.id = "";
      this.showDelete = false;
    },
    closeEdit() {
      if (this.showDropdown !== null && this.delEditOptions)
        this.showDropdown = null;
    },
    openOptions(e) {
      if (!this.delEditOptions) {
        this.showDropdown = e;
        this.delEditOptions = true;
      } else {
        this.showDropdown = null;
        this.delEditOptions = false;
      }
    },
    doDeleteReport() {
      // if (confirm(this.$t("conf_del", { title }))) {
      this.isLoading = true;
      this.deletereport(this.id)
        .then((res) => {
          this.closeDelete();
          this.getReports().then(() => {
            this.isLoading = false;
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit("close_report_edit", {
            status: "fail",
            mssg:
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1),
          });
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
      // }
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };
      this.isLoading = true;
      this.getReports(params).then(() => {
        this.isLoading = false;
      });
    },
    onPageSelect() {
      this.isLoading = true;
      this.getReports(this.params).then(() => {
        this.isLoading = false;
      });
    },
  },

  computed: {
    ...mapGetters(["reports", "reportMeta"]),
    tableColumns() {
      return [
        [this.$t(""), "index"],
        [this.$t("title"), "title"],
        [this.$t("devices"), "column2"],
        ["action", "column3"],
      ];
    },
    paginationMeta() {
      return this.reportMeta;
    },
  },
  watch: {
    reports: {
      handler: function() {
        this.dataTable = this.reports;
      },
      deep: true,
    },
    params: {
      handler: function() {
        this.onPageSelect();
      },
      deep: true,
    },
  },
};
</script>
<style src="../../assets/css/style.css"></style>
<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}
th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.flex {
  display: flex;
}
.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 4rem;
  top: 2.5rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 1px;
  z-index: 2;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
  cursor: pointer;
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}
.gray-bg {
  background-color: rgba(240, 244, 251, 0.6);
}
tr th {
  border-bottom: unset !important;
}
</style>

<i18n>
{
	"en": {
		"action": "Action",
		"conf_del": "Confirm Delete {name}",
		"del": "Delete",
		"edit": "Edit",
		"no_rep_yet": "You have no report yet",
		"title": "Title"
	},
	"es": {
		"action": "Acción",
		"conf_del": "Confirmar eliminación {name}",
		"del": "Borrar",
		"edit": "Editar",
		"no_rep_yet": "Aún no tienes un informe",
		"title": "Título"
	},
	"fr": {
		"action": "action",
		"conf_del": "Confirmer la suppression {name}",
		"del": "Effacer",
		"edit": "modifier",
		"no_rep_yet": "Vous n'avez pas encore de rapport",
		"title": "Titre"
	},
	"sw": {
		"action": "Hatua",
		"conf_del": "Thibitisha Futa {name}",
		"del": "Futa",
		"edit": "Hariri",
		"no_rep_yet": "Bado huna ripoti",
		"title": "Kichwa"
	}
}
</i18n>
